<template>
  <el-card class="main-card">
    <template #header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">货品管理</el-breadcrumb-item>
        <el-breadcrumb-item>款式信息（SKU）</el-breadcrumb-item>
      </el-breadcrumb>
    </template>
    <el-form :model="querys" ref="querys" label-width="90px" class="search-form">
      <el-row>
        <el-form-item label="关键词" prop="keyword">
          <el-col>
            <el-input v-model="querys.keyword" prefix-icon="Search" @keyup.enter="fetchs"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="SKU编号" prop="detailCode">
          <el-col style="width: 120px">
            <el-input v-model="detailCode" @keyup.enter="fetchs"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="" label-width="20px">
          <el-button type="primary" @click="fetchs()">
            搜索
          </el-button>
        </el-form-item>
      </el-row>
    </el-form>

    <div class="toolbar">
      <el-button type="primary" icon="Plus" @click="add()">
        新增
      </el-button>
      <el-button type="success" icon="Top" @click="batchStatus(true)" :disabled="selectedRows.length === 0">
        批量上架
      </el-button>
      <el-button type="warning" icon="Bottom" @click="batchStatus(false)" :disabled="selectedRows.length === 0">
        批量下架
      </el-button>
    </div>

    <basic-table class="table" :query="querys" @handler="tableHandler" :currHandler="currHandler"
      :seleHandler="handleSelectionChange">
      <template v-slot:productImg="scope">
        <el-image style="height: 32px; width: 32px" lazy :src="apiUrl + 'static/code/' + scope.row.detailCode + '?t=0'"
          :preview-src-list="[apiUrl + 'static/code/' + scope.row.detailCode + '?t=1']">
          <template #error>
            <img style="width: 100%" src="~@/assets/imgunfine.jpg" alt="" />
          </template>
        </el-image>
      </template>

      <template v-slot:productType="scope">
        <span>{{ getProductTypeLabel(scope.row.productType) }}</span>
      </template>

      <template v-slot:status="scope">
        <el-tag v-if="isEnabledStatus(scope.row.status)" type="success" size="small">已上架</el-tag>
        <el-tag v-else type="info" size="small">已下架</el-tag>
      </template>

      <template v-slot:toolbar="scope">
        <el-button @click="edit(scope.row)" type="primary" link size="small">
          [编辑]
        </el-button>
        <el-button v-if="isDisabledStatus(scope.row.status)" @click="updateStatus(scope.row, true)" type="success" link size="small">
          [上架]
        </el-button>
        <el-button v-if="isEnabledStatus(scope.row.status)" @click="updateStatus(scope.row, false)" type="warning" link size="small">
          [下架]
        </el-button>
        <el-button @click="del(scope.row)" type="primary" link size="small">
          [删除]
        </el-button>
      </template>
    </basic-table>

    <static-dialog ref="dialog" class="dialog" title="款式信息维护SKU" :opened="opened" :ok="submit" width="960px">
      <el-tabs v-model="skuTab" @tab-change="handleSkuTabChange">
        <el-tab-pane label="基础信息" name="base">
          <el-form :model="forms" :rules="rules" ref="forms" :label-width="labelWidth">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="16" :md="16" :lg="16" :xl="16" v-if="!forms.id">
                <el-form-item label="归属的款式" prop="chooseSpu">
                  <el-autocomplete style="width: 95%" v-model="chooseSpu.value" :fetch-suggestions="searchSpuAsync"
                    placeholder="请输入Spu信息内容" @select="chooseSpuHandle">
                  </el-autocomplete>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6" v-if="!forms.id">
                <el-form-item label="" label-width="0" style="max-width: 85%">
                  <el-input v-model="chooseSpu.productCode" autocomplete="off" disabled placeholder="SPU编号">
                  </el-input>
                </el-form-item>
              </el-col>

              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <el-form-item label="款式大类" prop="category">
                  <el-select v-model="forms.category" placeholder="请选择" disabled>
                    <el-option v-for="item in dict.categorys" :key="item.id" :label="item.name" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <el-form-item label="对应材质" prop="metalCode">
                  <el-select v-model="forms.metalCode" placeholder="请选择" @change="chooseOption($event, dict.metals)"
                    :disabled="forms.id">
                    <el-option v-for="item in dict.metals" :key="item.id" :label="item.value" :value="item.name">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :xs="24" :sm="16" :md="16" :lg="16" :xl="16">
                <el-form-item label="款式名称" prop="detailName" style="width: 95%">
                  <el-input v-model="forms.detailName" autocomplete="off">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
                <el-form-item label="" label-width="0" prop="detailCode">
                  <el-input v-model="forms.detailCode" autocomplete="off" placeholder="SKU编号" disabled>
                  </el-input>
                </el-form-item>
              </el-col>

              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <el-form-item label="产品类型" prop="productType">
                  <el-select v-model="forms.productType" placeholder="请选择" @change="handleProductTypeChange">
                    <el-option v-for="item in productTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <el-form-item label="组合编码" prop="comboCode">
                  <el-input v-model="forms.comboCode" autocomplete="off" placeholder="组合编码"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <el-form-item label="产品大类" prop="productBizType">
                  <el-select v-model="forms.productBizType" clearable placeholder="请选择" @change="handleProductBizTypeChange">
                    <el-option v-for="item in productBizTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <el-form-item label="品类大类" prop="productCategoryType">
                  <el-select v-model="forms.productCategoryType" filterable placeholder="请选择">
                    <el-option v-for="item in dict.productCategoryTypes" :key="item.id" :label="item.name" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <el-form-item label="产品状态" prop="status">
                  <el-select v-model="forms.status" placeholder="请选择">
                    <el-option label="上架" value="enabled"> </el-option>
                    <el-option label="下架" value="disabled"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                <el-form-item label="自定义款号" prop="serialCode">
                  <el-input v-model="forms.serialCode" autocomplete="off" placeholder="自定义款号"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                <el-form-item label="规格" prop="detailUnit" style="max-width: 85%">
                  <el-input v-model="forms.detailUnit" autocomplete="off"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                <el-form-item label="字印内容" prop="stampText">
                  <el-input v-model="forms.stampText"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="16" :md="16" :lg="16" :xl="16">
                <el-form-item label="工艺" prop="crafts">
                  <el-select v-model="forms.crafts" multiple filterable allow-create default-first-option clearable
                    placeholder="可多选，支持自定义输入" aria-label="Craft selection">
                    <el-option v-for="item in dict.crafts" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-form-item label="备注" prop="remark">
                  <el-input v-model="forms.remark" type="textarea" :rows="3" maxlength="500" show-word-limit placeholder="请输入备注"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-tab-pane>

        <el-tab-pane label="尺寸参数" name="sizeSpec" :disabled="!forms.detailCode">
          <el-form :model="forms" :label-width="labelWidth">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                <el-form-item label="产品高" prop="productHeight">
                  <el-input type="number" v-model="forms.productHeight" :disabled="isBizTypeFieldDisabled('dimension')" :placeholder="getBizTypeFieldPlaceholder('dimension')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                <el-form-item label="产品宽" prop="productWidth">
                  <el-input type="number" v-model="forms.productWidth" :disabled="isBizTypeFieldDisabled('dimension')" :placeholder="getBizTypeFieldPlaceholder('dimension')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                <el-form-item label="产品厚" prop="productThickness">
                  <el-input type="number" v-model="forms.productThickness" :disabled="isBizTypeFieldDisabled('dimension')" :placeholder="getBizTypeFieldPlaceholder('dimension')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                <el-form-item label="产品直径" prop="productDiameter">
                  <el-input type="number" v-model="forms.productDiameter" :disabled="isBizTypeFieldDisabled('dimension')" :placeholder="getBizTypeFieldPlaceholder('dimension')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                <el-form-item label="镯臂直径" prop="bangleArmDiameter">
                  <el-input type="number" v-model="forms.bangleArmDiameter" :disabled="isBizTypeFieldDisabled('dimension')" :placeholder="getBizTypeFieldPlaceholder('dimension')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                <el-form-item :label="productSizeLabel" prop="productSize">
                  <el-input type="number" v-model="forms.productSize" :disabled="isBizTypeFieldDisabled('productSize')" :placeholder="getBizTypeFieldPlaceholder('productSize')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                <el-form-item label="尺寸单位" prop="productSizeUnit">
                  <el-select v-model="forms.productSizeUnit" clearable :placeholder="getBizTypeFieldPlaceholder('productSize', '请选择')" :disabled="isBizTypeFieldDisabled('productSize')">
                    <el-option v-for="item in dict.productSizeUnit" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-divider content-position="left">链材参数</el-divider>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                <el-form-item label="配链名称" prop="chainName">
                  <el-select v-model="forms.chainName" filterable clearable placeholder="请选择">
                    <el-option v-for="item in dict.chainName" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                <el-form-item label="链材质" prop="chainMaterial">
                  <el-select v-model="forms.chainMaterial" filterable clearable placeholder="请选择">
                    <el-option v-for="item in dict.chainMaterial" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                <el-form-item label="链颜色" prop="chainColor">
                  <el-select v-model="forms.chainColor" filterable clearable placeholder="请选择">
                    <el-option v-for="item in dict.chainColor" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                <el-form-item label="链功能" prop="chainFunction">
                  <el-select v-model="forms.chainFunction" filterable clearable placeholder="请选择">
                    <el-option v-for="item in dict.chainFunction" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-tab-pane>

        <el-tab-pane label="主副石参数" name="stoneSpec" :disabled="!forms.detailCode">
          <el-form :model="forms" :label-width="labelWidth">
            <el-divider content-position="left">主石参数</el-divider>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                <el-form-item label="主石名称" prop="mainStoneName">
                  <el-select v-model="forms.mainStoneName" filterable clearable placeholder="请选择">
                    <el-option v-for="item in dict.mainStoneName" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                <el-form-item label="主石颜色" prop="mainStoneColor">
                  <el-select v-model="forms.mainStoneColor" filterable clearable placeholder="请选择">
                    <el-option v-for="item in dict.mainStoneColor" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              </el-row>
              <el-row :gutter="10">
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                <el-form-item label="主石尺寸" prop="mainStoneSize"><el-input type="number" v-model="forms.mainStoneSize"></el-input></el-form-item>
              </el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                <el-form-item label="主石石重" prop="mainStoneWeight"><el-input type="number" v-model="forms.mainStoneWeight"></el-input></el-form-item>
              </el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                <el-form-item label="主石粒数" prop="mainStoneCount"><el-input type="number" v-model="forms.mainStoneCount"></el-input></el-form-item>
              </el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                <el-form-item label="主石宽" prop="mainStoneWidth"><el-input type="number" v-model="forms.mainStoneWidth"></el-input></el-form-item>
              </el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                <el-form-item label="主石高" prop="mainStoneHeight"><el-input type="number" v-model="forms.mainStoneHeight"></el-input></el-form-item>
              </el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                <el-form-item label="主石厚" prop="mainStoneThickness"><el-input type="number" v-model="forms.mainStoneThickness"></el-input></el-form-item>
              </el-col>
              
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                <el-form-item label="钻石颜色" prop="diamondColor">
                  <el-select v-model="forms.diamondColor" filterable clearable :placeholder="isDiamondMainStone ? '请选择' : '主石为钻石时可选'" :disabled="!isDiamondMainStone">
                    <el-option v-for="item in dict.diamondColor" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                <el-form-item label="钻石净度" prop="diamondClarity">
                  <el-select v-model="forms.diamondClarity" filterable clearable :placeholder="isDiamondMainStone ? '请选择' : '主石为钻石时可选'" :disabled="!isDiamondMainStone">
                    <el-option v-for="item in dict.diamondClarity" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                <el-form-item label="副石总重" prop="sideStoneTotalWeight"><el-input type="number" v-model="forms.sideStoneTotalWeight"></el-input></el-form-item>
              </el-col>
            </el-row>

            <el-divider content-position="left">副石1</el-divider>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8"><el-form-item label="副石1名称" prop="sideStone1Name"><el-input v-model="forms.sideStone1Name" :disabled="!isSideStoneEditable"></el-input></el-form-item></el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8"><el-form-item label="副石1颜色" prop="sideStone1Color"><el-input v-model="forms.sideStone1Color" :disabled="!isSideStoneEditable"></el-input></el-form-item></el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8"><el-form-item label="副石1粒数" prop="sideStone1Count"><el-input type="number" v-model="forms.sideStone1Count" :disabled="!isSideStoneEditable"></el-input></el-form-item></el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8"><el-form-item label="副石1石重" prop="sideStone1Weight"><el-input type="number" v-model="forms.sideStone1Weight" :disabled="!isSideStoneEditable"></el-input></el-form-item></el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8"><el-form-item label="副石1尺寸" prop="sideStone1Size"><el-input type="number" v-model="forms.sideStone1Size" :disabled="!isSideStoneEditable"></el-input></el-form-item></el-col>
            </el-row>

            <el-divider content-position="left">副石2</el-divider>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8"><el-form-item label="副石2名称" prop="sideStone2Name"><el-input v-model="forms.sideStone2Name" :disabled="!isSideStoneEditable"></el-input></el-form-item></el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8"><el-form-item label="副石2颜色" prop="sideStone2Color"><el-input v-model="forms.sideStone2Color" :disabled="!isSideStoneEditable"></el-input></el-form-item></el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8"><el-form-item label="副石2粒数" prop="sideStone2Count"><el-input type="number" v-model="forms.sideStone2Count" :disabled="!isSideStoneEditable"></el-input></el-form-item></el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8"><el-form-item label="副石2石重" prop="sideStone2Weight"><el-input type="number" v-model="forms.sideStone2Weight" :disabled="!isSideStoneEditable"></el-input></el-form-item></el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8"><el-form-item label="副石2尺寸" prop="sideStone2Size"><el-input type="number" v-model="forms.sideStone2Size" :disabled="!isSideStoneEditable"></el-input></el-form-item></el-col>
            </el-row>

            <el-divider content-position="left">副石3</el-divider>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8"><el-form-item label="副石3名称" prop="sideStone3Name"><el-input v-model="forms.sideStone3Name" :disabled="!isSideStoneEditable"></el-input></el-form-item></el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8"><el-form-item label="副石3颜色" prop="sideStone3Color"><el-input v-model="forms.sideStone3Color" :disabled="!isSideStoneEditable"></el-input></el-form-item></el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8"><el-form-item label="副石3粒数" prop="sideStone3Count"><el-input type="number" v-model="forms.sideStone3Count" :disabled="!isSideStoneEditable"></el-input></el-form-item></el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8"><el-form-item label="副石3石重" prop="sideStone3Weight"><el-input type="number" v-model="forms.sideStone3Weight" :disabled="!isSideStoneEditable"></el-input></el-form-item></el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8"><el-form-item label="副石3尺寸" prop="sideStone3Size"><el-input type="number" v-model="forms.sideStone3Size" :disabled="!isSideStoneEditable"></el-input></el-form-item></el-col>
            </el-row>
          </el-form>
        </el-tab-pane>

        <el-tab-pane label="供应链信息" name="supplier">
          <el-form :model="forms" label-width="110px">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <el-form-item label="所属品牌" prop="brandName" style="max-width: 85%">
                  <el-select v-model="forms.brandName" filterable placeholder="请选择">
                    <el-option v-for="item in dict.brands" :key="item.id" :label="item.name" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <el-form-item label="品牌款号" prop="brandModelCode" style="max-width: 85%">
                  <el-input v-model="forms.brandModelCode" autocomplete="off"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <el-form-item label="默认工厂" prop="factoryName" style="max-width: 85%">
                  <el-select v-model="forms.factoryName" filterable placeholder="请选择">
                    <el-option v-for="item in dict.factorys" :key="item.id" :label="item.name" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <el-form-item label="工厂款号" prop="factoryModelCode" style="max-width: 85%">
                  <el-input v-model="forms.factoryModelCode" autocomplete="off"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <el-form-item label="工厂出货周期" prop="factoryDeliveryCycleDays" style="max-width: 85%">
                  <el-input type="number" v-model.number="forms.factoryDeliveryCycleDays" autocomplete="off" min="0" placeholder="请输入天数">
                    <template #suffix>天</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <el-form-item label="入库周期" prop="inboundCycleDays" style="max-width: 85%">
                  <el-input type="number" v-model.number="forms.inboundCycleDays" autocomplete="off" min="0" placeholder="请输入天数">
                    <template #suffix>天</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div class="sub-toolbar">
            <el-button type="primary" icon="Plus" @click="openSupplierDialog">新增报价</el-button>
          </div>
          <el-alert v-if="!forms.id" title="请先保存SKU后再维护供应商报价" type="info" show-icon :closable="false" style="margin-bottom: 10px;" />
          <el-table :data="supplierList" border size="small" style="width: 100%">
            <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
            <el-table-column prop="supplierName" label="供应商" width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="supplierCode" label="供应商编号" width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="factoryModelCode" label="工厂款号" width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="quotePrice" label="报价" width="100" align="right"></el-table-column>
            <el-table-column prop="createDate" label="创建时间" width="150" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" width="140" fixed="right" align="center">
              <template #default="scope">
                <el-button link size="small" @click="editSupplier(scope.row)">编辑</el-button>
                <el-button link size="small" @click="removeSupplier(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <el-tab-pane label="标准费用" name="costFee">
          <el-alert :title="standardFeeNotice" type="info" show-icon :closable="false" style="margin-bottom: 10px;" />
          <el-form :model="forms" :label-width="labelWidth">
            <el-divider content-position="left">标准费用</el-divider>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8"><el-form-item label="总重范围" prop="totalWeight"><el-input v-model="forms.totalWeight" autocomplete="off"></el-input></el-form-item></el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8"><el-form-item label="金重范围" prop="metalWeight"><el-input v-model="forms.metalWeight" autocomplete="off"></el-input></el-form-item></el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8"><el-form-item label="费用克重" prop="weightRange"><el-input v-model="forms.weightRange" placeholder="如 2.8-3.2g"></el-input></el-form-item></el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8"><el-form-item label="标准克重" prop="standardWeight"><el-input-number v-model="forms.standardWeight" :min="0" :precision="4" :controls="false" style="width: 100%" placeholder="克"></el-input-number></el-form-item></el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8"><el-form-item label="克工费" prop="laborUnitPrice"><el-input-number v-model="forms.laborUnitPrice" :min="0" :precision="4" :controls="false" style="width: 100%" placeholder="元/克"></el-input-number></el-form-item></el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8"><el-form-item label="件工费" prop="laborPiecePrice"><el-input-number v-model="forms.laborPiecePrice" :min="0" :precision="4" :controls="false" style="width: 100%" placeholder="元/件"></el-input-number></el-form-item></el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8"><el-form-item label="附加费/件" prop="additionalPieceFee"><el-input-number v-model="forms.additionalPieceFee" :min="0" :precision="4" :controls="false" style="width: 100%" placeholder="元/件"></el-input-number></el-form-item></el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8"><el-form-item label="一口价" prop="fixedPrice"><el-input-number v-model="forms.fixedPrice" :min="0" :precision="4" :controls="false" style="width: 100%" placeholder="元"></el-input-number></el-form-item></el-col>
            </el-row>
            <el-alert :title="'标准工费：' + standardLaborFeeText + ' 元（标准克重 × 克工费 + 件工费）'" type="success" :closable="false" style="margin-bottom: 10px;" />
            <el-divider content-position="left">其他费用</el-divider>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8"><el-form-item label="基础工费" prop="baseLaborFee"><el-input type="number" v-model="forms.baseLaborFee"></el-input></el-form-item></el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8"><el-form-item label="金工费" prop="goldLaborFee"><el-input type="number" v-model="forms.goldLaborFee"></el-input></el-form-item></el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8"><el-form-item label="镶石费" prop="stoneSettingFee"><el-input type="number" v-model="forms.stoneSettingFee"></el-input></el-form-item></el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8"><el-form-item label="配石费" prop="stoneMatchingFee"><el-input type="number" v-model="forms.stoneMatchingFee"></el-input></el-form-item></el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8"><el-form-item label="附加费1" prop="extraFee1"><el-input type="number" v-model="forms.extraFee1"></el-input></el-form-item></el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8"><el-form-item label="附加费2" prop="extraFee2"><el-input type="number" v-model="forms.extraFee2"></el-input></el-form-item></el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8"><el-form-item label="证书费" prop="certificateFee"><el-input type="number" v-model="forms.certificateFee"></el-input></el-form-item></el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8"><el-form-item label="其他费用" prop="otherFee"><el-input type="number" v-model="forms.otherFee"></el-input></el-form-item></el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8"><el-form-item label="配件名称" prop="accessoryName"><el-input v-model="forms.accessoryName"></el-input></el-form-item></el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8"><el-form-item label="配件费" prop="accessoryFee"><el-input type="number" v-model="forms.accessoryFee"></el-input></el-form-item></el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8"><el-form-item label="税点" prop="taxRate"><el-input type="number" v-model="forms.taxRate"></el-input></el-form-item></el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8"><el-form-item label="采购参考价" prop="purchasePrice"><el-input type="number" v-model="forms.purchasePrice"></el-input></el-form-item></el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8"><el-form-item label="售卖价" prop="sellPrice"><el-input type="number" v-model="forms.sellPrice"></el-input></el-form-item></el-col>
            </el-row>
          </el-form>
        </el-tab-pane>

        <el-tab-pane label="组合产品" name="combo" :disabled="!forms.id || !isComboProductType(forms.productType)">
          <div class="sub-toolbar">
            <el-button type="primary" icon="Plus" @click="openComboDialog">新增组合关系</el-button>
          </div>
          <el-alert v-if="!isComboProductType(forms.productType)" title="仅组合主产品(Main)或组合配件(Item)可维护组合关系" type="warning"
            show-icon :closable="false" style="margin-bottom: 10px;" />
          <el-table :data="comboList" border size="small" style="width: 100%">
            <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
            <el-table-column prop="comboCode" label="组合编码" width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="detailCode" label="配件SKU" width="130" show-overflow-tooltip></el-table-column>
            <el-table-column prop="detailName" label="配件名称" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="quantity" label="数量" width="80" align="center"></el-table-column>
            <el-table-column label="操作" width="140" fixed="right" align="center">
              <template #default="scope">
                <el-button link size="small" @click="editCombo(scope.row)">编辑</el-button>
                <el-button link size="small" @click="removeCombo(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </static-dialog>

    <static-dialog ref="supplierDialog" class="dialog" title="供应商报价" :ok="submitSupplier">
      <el-form :model="supplierForm" ref="supplierForm" label-width="110px">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <el-form-item label="供应商" prop="supplierCode">
              <el-select v-model="supplierForm.supplierCode" filterable placeholder="请选择" @change="handleSupplierChange">
                <el-option v-for="item in suppliers" :key="item.supplierCode || item.id"
                  :label="item.supplierName || item.text" :value="item.supplierCode || item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <el-form-item label="工厂款号" prop="factoryModelCode">
              <el-input v-model="supplierForm.factoryModelCode" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <el-form-item label="报价" prop="quotePrice">
              <el-input type="number" v-model="supplierForm.quotePrice" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </static-dialog>

    <static-dialog ref="comboDialog" class="dialog" title="组合关系" :ok="submitCombo">
      <el-form :model="comboForm" ref="comboForm" label-width="110px">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item label="当前SKU类型">
              <el-tag size="small">{{ getProductTypeLabel(forms.productType) }}</el-tag>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item :label="comboTargetLabel" prop="comboTarget">
              <el-autocomplete v-model="comboSearchText" :fetch-suggestions="searchSkuAsync"
                placeholder="输入SKU编号或名称" @select="handleComboSelect" style="width: 100%">
              </el-autocomplete>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <el-form-item label="配件数量" prop="quantity">
              <el-input-number v-model="comboForm.quantity" :min="1" :max="9999" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </static-dialog>
  </el-card>
</template>
<script>
const CRAFTS_SEPARATOR = ",";
import {
  fetchSpuList,
  fetchSkuList,
  fetchSkuDetail,
  submitSku,
  delSku,
  fetchDetailCode,
  searchSkuList,
  batchSkuStatus,
  fetchSkuSuppliers,
  submitSkuSupplier,
  deleteSkuSupplier,
  fetchSkuCombos,
  submitSkuCombo,
  deleteSkuCombo,
  fetchSkuDictAll,
  fetchSkuDictList
} from "@/api/product";
import { fetchPurchaseSupplier } from "@/api/purchase";
import StaticDialog from "@/components/static-dialog.vue";
import BasicTable from "@/components/basic-table.vue";
export default {
  name: "SkuList",
  components: { StaticDialog, BasicTable },
  data() {
    return {
      apiUrl: "",
      detailCode: "",
      chooseSpu: {},
      skuDetailDialogVisible: false,
      selectedRows: [],
      skuTab: "base",
      suppliers: [],
      supplierList: [],
      supplierForm: {},
      comboList: [],
      comboForm: {
        quantity: 1
      },
      comboSearchText: "",

      querys: {
        keyword: "",
        filters: [],
        columns: [
          { type: "selection", width: "55" },
          { type: "index", label: "序号" },
          { prop: "category", label: "大类名称", sortable: true, searchable: true, width: "90", showOverflowTooltip: true, },
          { prop: "productCode", label: "SPU编号", sortable: true, searchable: true, width: "90", showOverflowTooltip: true, },
          { prop: "detailCode", label: "SKU编号", sortable: true, searchable: true, width: "130", showOverflowTooltip: true, },
          { prop: "serialCode", label: "自定编号", sortable: true, searchable: true, width: "130", showOverflowTooltip: true, },
          { type: "template", prop: "productImg", label: "图片", width: "70", },
          { prop: "detailName", label: "SKU名称", sortable: true, searchable: true, width: "160", showOverflowTooltip: true },
          { prop: "productBizType", label: "产品大类", sortable: true, searchable: true, width: "90", showOverflowTooltip: true },
          { prop: "productCategoryType", label: "品类大类", sortable: true, searchable: true, width: "100", showOverflowTooltip: true },
          { type: "template", prop: "productType", label: "产品类型", sortable: true, searchable: true, width: "90", showOverflowTooltip: true },
          { prop: "comboCode", label: "组合编码", sortable: true, searchable: true, width: "110", showOverflowTooltip: true },
          { prop: "detailUnit", label: "款式规格", sortable: true, searchable: true, width: "100", showOverflowTooltip: true },
          { type: "template", prop: "status", label: "状态", width: "90", },
          { prop: "productSize", label: "产品尺寸", sortable: true, searchable: true, width: "90", showOverflowTooltip: true },
          { prop: "productSizeUnit", label: "尺寸单位", searchable: true, width: "80", showOverflowTooltip: true },
          { prop: "brandName", label: "品牌名称", sortable: true, searchable: true, width: "110", showOverflowTooltip: true, permission: 3, },
          { prop: "brandModelCode", label: "品牌款号", sortable: true, searchable: true, width: "130", showOverflowTooltip: true, permission: 3, },
          { prop: "factoryName", label: "工厂名", sortable: true, searchable: true, width: "130", showOverflowTooltip: true, permission: 3, },
          { prop: "factoryModelCode", label: "工厂款号", sortable: true, searchable: true, width: "130", showOverflowTooltip: true, permission: 3, },
          { prop: "factoryDeliveryCycleDays", label: "工厂出货周期", sortable: true, width: "120", align: "right", permission: 3, },
          { prop: "inboundCycleDays", label: "入库周期", sortable: true, width: "100", align: "right", permission: 3, },
          { prop: "standardWeight", label: "标准克重", sortable: true, width: "100", align: "right", permission: 3, },
          { prop: "laborUnitPrice", label: "克工费", sortable: true, width: "95", align: "right", permission: 3, },
          { prop: "laborPiecePrice", label: "件工费", sortable: true, width: "95", align: "right", permission: 3, },
          { prop: "fixedPrice", label: "一口价", sortable: true, width: "100", align: "right", permission: 3, },
          { prop: "purchasePrice", label: "采购价", sortable: true, width: "100", align: "right", permission: 3, },
          { prop: "sellPrice", label: "售价", sortable: true, width: "100", align: "right", permission: 3, },
          { prop: "remark", label: "备注", searchable: true, width: "150", showOverflowTooltip: true },
          { prop: "createDate", label: "创建时间", sortable: true, width: "140", showOverflowTooltip: true },
          { prop: "createUserName", label: "创建人", sortable: true, searchable: true, width: "100", },
          { prop: "updateDate", label: "修改时间", width: "150", sortable: true, showOverflowTooltip: true },
          { prop: "updateUserName", label: "最后修改", sortable: true, searchable: true, width: "100", },
          { type: "toolbar", label: "操作", width: "180" },
        ],

        sidx: "id",

        sord: "descending",
      },
      currRow: null,
      centerDialogVisible: false,
      dialogWidth: "30%",

      dict: {
        categorys: [],
        brands: [],
        factorys: [],
        metals: [],
        productCategoryTypes: [],
        mainStoneName: [],
        mainStoneColor: [],
        diamondColor: [],
        diamondClarity: [],
        chainName: [],
        chainMaterial: [],
        chainColor: [],
        chainFunction: [],
        productSizeUnit: [],
        crafts: [],
      },
      productTypeOptions: [
        { label: "普通产品", value: "Normal" },
        { label: "组合主产品", value: "Main" },
        { label: "组合配件", value: "Item" }
      ],
      productBizTypeOptions: [],
      forms: {},
      labelWidth: "110px",
      rules: {
        category: [
          { required: true, message: "请选择款式大类", trigger: "blur" },
        ],
        metalCode: [
          { required: true, message: "请选择款式的材质", trigger: "blur" },
        ],
        detailName: [
          { required: true, message: "请输入款式名称", trigger: "blur" },
          { min: 1, max: 30, message: "长度在1-30之间", trigger: "blur" },
        ],
        purchasePrice: [
          { required: true, message: "请输入采购参考价格", trigger: "blur" },
        ],
        sellPrice: [
          { required: true, message: "请输入售卖预估价格", trigger: "blur" },
        ],
        brandName: [
          { required: true, message: "请选择所属品牌", trigger: "blur" },
        ],
        factoryName: [
          { required: true, message: "请选择对应工厂", trigger: "blur" },
        ],
        status: [
          { required: true, message: "请选择款式状态", trigger: "blur" },
        ],
        productCategoryType: [
          { required: true, message: "请选择品类大类", trigger: "change" },
        ],
        productType: [
          { required: true, message: "请选择产品类型", trigger: "change" },
        ],
        comboCode: [
          {
            validator: (rule, value, callback) => {
              if (this.isComboProductType(this.forms.productType) && !value) {
                callback(new Error("组合主/配件必须填写组合编码"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ]
      },
    };
  },
  mounted() {
    this.fetchs();

    this.$kaung.dictionary("stock", "category").then((res) => { this.dict.categorys = res; });
    this.$kaung.dictionary("stock", "brand").then((res) => { this.dict.brands = res; });
    this.$kaung.dictionary("stock", "factory").then((res) => { this.dict.factorys = res; });
    this.$kaung.dictionary("stock", "metal").then((res) => { this.dict.metals = res; });
    this.$kaung.dictionary("stock", "productCategoryType").then((res) => { this.dict.productCategoryTypes = res; });
    this.loadSkuDicts();
    this.apiUrl = process.env.VUE_APP_BASEURL;
    fetchPurchaseSupplier().then((res) => {
      if (res && res.code === 200) {
        this.suppliers = Array.isArray(res.data) ? res.data : [];
      }
    });
  },
  computed: {
    comboTargetLabel() {
      return this.forms.productType === "Main" ? "组合配件SKU" : "组合主产品SKU";
    },
    isDiamondMainStone() {
      const value = String(this.forms.mainStoneName || "").trim().toLowerCase();
      if (!value) return false;
      return value.includes("钻石") || value.includes("diamond");
    },
    isSideStoneEditable() {
      return Number(this.forms.sideStoneTotalWeight) > 0;
    },
    productSizeLabel() {
      const bizType = this.forms.productBizType;
      if (bizType === "手镯") return "手镯手寸号";
      if (bizType === "手链") return "手链长度";
      if (bizType === "戒指") return "戒指手寸号";
      return "产品尺寸";
    },
    standardLaborFeeText() {
      const standardWeight = Number(this.forms.standardWeight || 0);
      const laborUnitPrice = Number(this.forms.laborUnitPrice || 0);
      const laborPiecePrice = Number(this.forms.laborPiecePrice || 0);
      return (standardWeight * laborUnitPrice + laborPiecePrice).toFixed(2);
    },
    standardFeeNotice() {
      return "标准费用为SKU默认报价参考，不自动覆盖采购/入库价；费用单位：元";
    }
  },
  methods: {
    isEnabledStatus(status) {
      return String(status || "").trim().toLowerCase() === "enabled";
    },
    isDisabledStatus(status) {
      return !this.isEnabledStatus(status);
    },
    normalizeStatus(status) {
      return this.isEnabledStatus(status) ? "enabled" : "disabled";
    },
    isComboProductType(productType) {
      return productType === "Main" || productType === "Item";
    },
    getProductTypeLabel(productType) {
      const option = this.productTypeOptions.find(item => item.value === productType);
      return option ? option.label : (productType || "-");
    },
    normalizeProductType(productType) {
      const value = String(productType || "").trim();
      if (!value) return "Normal";
      if (value === "Normal" || value === "Main" || value === "Item") return value;
      if (value === "普通产品") return "Normal";
      if (value === "组合主产品") return "Main";
      if (value === "组合配件") return "Item";
      return value;
    },
    isDimensionBizType() {
      return this.forms.productBizType === "手镯" || this.forms.productBizType === "手链" || this.forms.productBizType === "戒指";
    },
    isBizTypeFieldDisabled(fieldGroup) {
      if (fieldGroup === "dimension" || fieldGroup === "productSize") {
        return !this.isDimensionBizType();
      }
      return false;
    },
    getBizTypeFieldPlaceholder(fieldGroup, defaultPlaceholder = "") {
      if (!this.isBizTypeFieldDisabled(fieldGroup)) {
        return defaultPlaceholder;
      }
      if (fieldGroup === "dimension" || fieldGroup === "productSize") {
        return "因非手镯/手链/戒指产品大类无需录入";
      }
      return "当前无需录入";
    },
    handleProductBizTypeChange() {
      if (this.isBizTypeFieldDisabled("dimension")) {
        this.forms.productHeight = null;
        this.forms.productWidth = null;
        this.forms.productThickness = null;
        this.forms.productDiameter = null;
        this.forms.bangleArmDiameter = null;
        this.forms.productSize = null;
        this.forms.productSizeUnit = "";
      }
    },
    normalizeDictOptions(values) {
      return (values || []).map((item) => {
        if (item && typeof item === "object") {
          const value = item.value || item.name || item.label || "";
          const label = item.label || item.name || item.value || "";
          return { label, value };
        }
        const text = (item || item === 0) ? String(item).trim() : "";
        return { label: text, value: text };
      }).filter((item) => item.value !== "");
    },
    getSkuDictValues(data, dictCode) {
      if (!data || typeof data !== "object") return [];
      const code = String(dictCode || "");
      const camelCode = code.charAt(0).toLowerCase() + code.slice(1);
      const matchedKey = Object.keys(data).find((key) => {
        return key === code || key === camelCode || key.toLowerCase() === code.toLowerCase();
      });
      const values = matchedKey ? data[matchedKey] : [];
      return Array.isArray(values) ? values : [];
    },
    convertCraftsToArray(crafts) {
      if (Array.isArray(crafts)) return crafts;
      if (typeof crafts !== "string") return [];
      return crafts.split(CRAFTS_SEPARATOR).map((craftItem) => craftItem.trim()).filter(Boolean);
    },
    convertCraftsToPayload(crafts) {
      return Array.isArray(crafts) ? crafts.join(CRAFTS_SEPARATOR) : crafts;
    },
    sanitizeStoneDependentFields() {
      if (!this.isDiamondMainStone) {
        this.forms.diamondColor = "";
        this.forms.diamondClarity = "";
      }
      if (this.isSideStoneEditable) {
        return;
      }
      this.forms.sideStone1Name = "";
      this.forms.sideStone1Color = "";
      this.forms.sideStone1Count = null;
      this.forms.sideStone1Weight = null;
      this.forms.sideStone1Size = null;
      this.forms.sideStone2Name = "";
      this.forms.sideStone2Color = "";
      this.forms.sideStone2Count = null;
      this.forms.sideStone2Weight = null;
      this.forms.sideStone2Size = null;
      this.forms.sideStone3Name = "";
      this.forms.sideStone3Color = "";
      this.forms.sideStone3Count = null;
      this.forms.sideStone3Weight = null;
      this.forms.sideStone3Size = null;
    },
    validateRequiredSkuFields() {
      if (!this.forms.productCategoryType) {
        this.skuTab = "base";
        this.$message.warning("请选择品类大类");
        return false;
      }

      if (this.forms.factoryDeliveryCycleDays === "" || this.forms.factoryDeliveryCycleDays === null || this.forms.factoryDeliveryCycleDays === undefined) {
        this.skuTab = "supplier";
        this.$message.warning("请输入工厂出货周期");
        return false;
      }

      if (Number(this.forms.factoryDeliveryCycleDays) < 0) {
        this.skuTab = "supplier";
        this.$message.warning("工厂出货周期不能小于0");
        return false;
      }

      if (!Number.isInteger(Number(this.forms.factoryDeliveryCycleDays))) {
        this.skuTab = "supplier";
        this.$message.warning("工厂出货周期必须为整数天数");
        return false;
      }

      if (this.forms.inboundCycleDays === "" || this.forms.inboundCycleDays === null || this.forms.inboundCycleDays === undefined) {
        this.skuTab = "supplier";
        this.$message.warning("请输入入库周期");
        return false;
      }

      if (Number(this.forms.inboundCycleDays) < 0) {
        this.skuTab = "supplier";
        this.$message.warning("入库周期不能小于0");
        return false;
      }

      if (!Number.isInteger(Number(this.forms.inboundCycleDays))) {
        this.skuTab = "supplier";
        this.$message.warning("入库周期必须为整数天数");
        return false;
      }

      this.forms.factoryDeliveryCycleDays = Number(this.forms.factoryDeliveryCycleDays);
      this.forms.inboundCycleDays = Number(this.forms.inboundCycleDays);
      return true;
    },
    loadSkuDicts() {
      fetchSkuDictAll().then((res) => {
        const data = res?.data || {};
        this.dict.mainStoneName = this.normalizeDictOptions(this.getSkuDictValues(data, "MainStoneName"));
        this.dict.mainStoneColor = this.normalizeDictOptions(this.getSkuDictValues(data, "MainStoneColor"));
        this.dict.diamondColor = this.normalizeDictOptions(this.getSkuDictValues(data, "DiamondColor"));
        this.dict.diamondClarity = this.normalizeDictOptions(this.getSkuDictValues(data, "DiamondClarity"));
        this.dict.chainName = this.normalizeDictOptions(this.getSkuDictValues(data, "ChainName"));
        this.dict.chainMaterial = this.normalizeDictOptions(this.getSkuDictValues(data, "ChainMaterial"));
        this.dict.chainColor = this.normalizeDictOptions(this.getSkuDictValues(data, "ChainColor"));
        this.dict.chainFunction = this.normalizeDictOptions(this.getSkuDictValues(data, "ChainFunction"));
        this.dict.productSizeUnit = this.normalizeDictOptions(this.getSkuDictValues(data, "ProductSizeUnit"));
        this.dict.crafts = this.normalizeDictOptions(this.getSkuDictValues(data, "Crafts"));
      }).catch(() => {
        this.$message.warning("SKU扩展字典加载失败");
      });
      fetchSkuDictList("ProductBizType").then((res) => {
        this.productBizTypeOptions = this.normalizeDictOptions(res?.data || []);
      }).catch(() => {
        this.productBizTypeOptions = [];
        this.$message.warning("产品大类字典加载失败");
      });
    },
    //搜索归属的SPU（请求后台数据）
    searchSpuAsync(queryString, callback) {
      console.log(queryString, callback);

      let search = {
        page: 1,
        rows: 10,
        columns: [
          { prop: "productCode", searchable: true },
          { prop: "productName", searchable: true },
          { prop: "category", searchable: true },
          { prop: "productMass", searchable: true },
          { prop: "brandCode", searchable: true },
          { prop: "brandName", searchable: true },
          { prop: "brandProductCode", searchable: true },
          { prop: "factoryCode", searchable: true },
          { prop: "factoryName", searchable: true },
          { prop: "factoryProductCode", searchable: true },
          { prop: "purchasePrice", searchable: true },
          { prop: "sellPrice", searchable: true },
        ],
        keyword: this.chooseSpu.value,
        queryType: 3,
      };
      fetchSpuList(search).then((res) => {
        console.log(res);
        //res.data.data
        let inputOptions = [];
        res.data.data.forEach(function (item) {
          inputOptions.push({
            value: item.productName,
            ...item,
          });
        });

        callback(inputOptions);
      });
    },
    //选择选中事件
    chooseSpuHandle(item) {
      console.log(item);
      this.forms.detailCode = "";
      this.forms.metalCode = "";

      this.chooseSpu = item;
      this.forms.category = item.category;
      this.forms.detailName = item.productName;
      this.forms.productID = item.id;
      this.forms.productCode = item.productCode;

      this.forms.totalWeight = item.productMass;
      this.forms.productBizType = item.productBizType;
      this.forms.productHeight = item.productHeight;
      this.forms.productWidth = item.productWidth;
      this.forms.productThickness = item.productThickness;
      this.forms.productDiameter = item.productDiameter;
      this.forms.bangleArmDiameter = item.bangleArmDiameter;
      this.forms.stampText = item.stampText;
      this.forms.crafts = this.convertCraftsToArray(item.crafts);

      this.forms.brandCode = item.brandCode;
      this.forms.brandName = item.brandName;
      this.forms.brandModelCode = item.brandProductCode;
      this.forms.factoryCode = item.factoryCode;
      this.forms.factoryName = item.factoryName;
      this.forms.factoryModelCode = item.factoryProductCode;

      this.forms.purchasePrice = item.purchasePrice;
      this.forms.sellPrice = item.sellPrice;

      this.forms.status = "disabled";
      this.forms.productType = "Normal";
      this.forms.comboCode = "";
      if (!this.forms.productBizType) {
        this.forms.productBizType = "套链";
      }
      this.handleProductBizTypeChange();
    },
    add() {
      this.currRow = {};
      this.$refs.dialog.toggle();
    },
    edit(row) {
      this.currRow = row;
      this.$refs.dialog.toggle();
    },
    del(row) {
      this.currRow = row;
      let that = this;

      this.$confirm("此操作将删除本行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        delSku(that.currRow.id).then((res) => {
          that.$message({
            type: res.type,
            message: res.content,
          });
          that.fetchs();
        });
      });
    },
    chooseOption(value, options) {
      let items = options.filter(function (item) {
        return item.name == value;
      });
      if (items && items.length > 0) {
        let that = this;
        fetchDetailCode({
          productCode: this.chooseSpu.productCode,
          metalCode: items[0].name,
        }).then((res) => {
          that.forms.detailCode = res.data;
        });
      }
    },
    opened() {
      let that = this;
      this.forms = {};
      this.chooseSpu = {};
      this.skuTab = "base";
      this.supplierList = [];
      this.comboList = [];
      this.supplierForm = {};
      this.comboForm = { quantity: 1 };
      this.comboSearchText = "";
      if (this.currRow && this.currRow.id) {
        fetchSkuDetail(this.currRow.id).then((res) => {
          that.forms = { ...res.data };
          that.forms.crafts = that.convertCraftsToArray(that.forms.crafts);
          that.forms.status = that.normalizeStatus(that.forms.status);
          if (!that.forms.productBizType) {
            that.forms.productBizType = "套链";
          }
          that.handleProductBizTypeChange();
          that.forms.productType = that.normalizeProductType(that.forms.productType);
          that.loadSupplierList();
          that.loadComboList();
        });
      } else {
        this.forms.status = "disabled";
        this.forms.productType = "Normal";
        this.forms.productBizType = "套链";
        this.forms.crafts = [];
        this.handleProductBizTypeChange();
      }
    },
    submit() {
      let that = this;

      if (!this.validateRequiredSkuFields()) return;

      this.$refs.forms.validate((valid) => {
        if (!valid) return;

        let chooseBrands = that.dict.brands.filter(function (item) {
          return item.value == that.forms.brandName;
        });
        let chooseFactorys = that.dict.factorys.filter(function (item) {
          return item.value == that.forms.factoryName;
        });
        if (chooseBrands.length == 0 || chooseFactorys.length == 0) {
          that.$message({
            message: "请重新选择工厂和品牌",
          });
          return;
        }

        // let chooseMetals = that.dict.metals.filter(function (item) {
        //   return item.value == that.forms.metalCode;
        // });

        that.forms.brandCode = chooseBrands[0].name;
        that.forms.factoryCode = chooseFactorys[0].name;
        if (!that.forms.id) {
          that.forms.status = "disabled";
        }
        that.forms.status = that.normalizeStatus(that.forms.status);
        that.forms.productType = that.normalizeProductType(that.forms.productType);
        if (!that.isComboProductType(that.forms.productType)) {
          that.forms.comboCode = "";
        }
        that.sanitizeStoneDependentFields();
        that.forms.crafts = that.convertCraftsToPayload(that.forms.crafts);
        submitSku(that.forms).then((res) => {
          that.$message({
            type: res.type,
            message: res.content,
          });

          if (res.data) {
            that.fetchs();
            that.$refs.dialog.toggle();
          }
        });
      });
    },
    handleProductTypeChange(val) {
      if (!this.isComboProductType(val)) {
        this.forms.comboCode = "";
        this.comboList = [];
      }
    },
    handleSkuTabChange(name) {
      if (name === "supplier" && this.forms.id) {
        this.loadSupplierList();
      }
      if (name === "combo" && this.forms.id && this.isComboProductType(this.forms.productType)) {
        this.loadComboList();
      }
    },
    loadSupplierList() {
      if (!this.forms.id) return;
      const search = {
        page: 1,
        rows: 200,
        keyword: "",
        filters: [
          { name: "detailID", value: this.forms.id, operate: 0 }
        ],
        sidx: "id",
        sord: "descending"
      };
      fetchSkuSuppliers(search).then((res) => {
        this.supplierList = (res.data && res.data.data) ? res.data.data : (res.data || []);
      });
    },
    openSupplierDialog() {
      if (!this.forms.id) {
        this.$message.warning("请先保存SKU后再维护报价");
        return;
      }
      this.supplierForm = {
        detailID: this.forms.id,
        supplierCode: "",
        supplierName: "",
        factoryModelCode: "",
        quotePrice: ""
      };
      this.$refs.supplierDialog.toggle();
    },
    editSupplier(row) {
      this.supplierForm = { ...row };
      this.$refs.supplierDialog.toggle();
    },
    removeSupplier(row) {
      this.$confirm("确定要删除该供应商报价吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        deleteSkuSupplier(row.id).then((res) => {
          this.$message({ type: res.type, message: res.content });
          this.loadSupplierList();
        });
      });
    },
    handleSupplierChange(code) {
      const current = this.suppliers.find(s => (s.supplierCode || s.value) === code);
      this.supplierForm.supplierName = current ? (current.supplierName || current.text || "") : "";
      if (!this.supplierForm.factoryModelCode) {
        this.supplierForm.factoryModelCode = this.forms.factoryModelCode || "";
      }
    },
    submitSupplier() {
      if (!this.forms.id) return;
      if (!this.supplierForm.supplierCode) {
        this.$message.warning("请选择供应商");
        return;
      }
      if (!this.supplierForm.quotePrice && this.supplierForm.quotePrice !== 0) {
        this.$message.warning("请输入报价");
        return;
      }
      this.supplierForm.detailID = this.forms.id;
      submitSkuSupplier(this.supplierForm).then((res) => {
        this.$message({ type: res.type, message: res.content });
        if (res.code === 200 || res.data) {
          this.$refs.supplierDialog.toggle();
          this.loadSupplierList();
        }
      });
    },
    loadComboList() {
      if (!this.forms.id || !this.isComboProductType(this.forms.productType)) return;
      const filterField = this.forms.productType === "Main" ? "comboID" : "detailID";
      const search = {
        page: 1,
        rows: 200,
        keyword: "",
        filters: [
          { name: filterField, value: this.forms.id, operate: 0 }
        ],
        sidx: "id",
        sord: "descending"
      };
      fetchSkuCombos(search).then((res) => {
        this.comboList = (res.data && res.data.data) ? res.data.data : (res.data || []);
      });
    },
    openComboDialog() {
      if (!this.forms.id || !this.isComboProductType(this.forms.productType)) {
        this.$message.warning("仅组合主产品或组合配件可维护组合关系");
        return;
      }
      this.comboForm = {
        quantity: 1
      };
      if (this.forms.productType === "Main") {
        this.comboForm.comboID = this.forms.id;
      } else {
        this.comboForm.detailID = this.forms.id;
      }
      this.comboSearchText = "";
      this.$refs.comboDialog.toggle();
    },
    editCombo(row) {
      this.comboForm = { ...row };
      this.comboSearchText = row.detailCode || row.detailName || "";
      this.$refs.comboDialog.toggle();
    },
    removeCombo(row) {
      this.$confirm("确定要删除该组合关系吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        deleteSkuCombo(row.id).then((res) => {
          this.$message({ type: res.type, message: res.content });
          this.loadComboList();
        });
      });
    },
    searchSkuAsync(queryString, callback) {
      if (!queryString || queryString.trim().length < 2) {
        callback([]);
        return;
      }
      searchSkuList(queryString).then((res) => {
        const list = res?.data?.data || [];
        const targetType = this.forms.productType === "Main" ? "Item" : "Main";
        const suggestions = list.filter(item => !targetType || item.productType === targetType).map(item => ({
          value: `${item.detailCode || ''} ${item.detailName || ''}`.trim(),
          ...item
        }));
        callback(suggestions);
      }).catch(() => callback([]));
    },
    handleComboSelect(item) {
      if (!item) return;
      if (this.forms.productType === "Main") {
        this.comboForm.detailID = item.id;
      } else {
        this.comboForm.comboID = item.id;
      }
      if (!this.comboForm.quantity) {
        this.comboForm.quantity = 1;
      }
    },
    submitCombo() {
      if (!this.forms.id || !this.isComboProductType(this.forms.productType)) return;
      if (!this.comboForm.quantity || this.comboForm.quantity <= 0) {
        this.$message.warning("请输入配件数量");
        return;
      }
      if (this.forms.productType === "Main" && !this.comboForm.detailID) {
        this.$message.warning("请选择组合配件SKU");
        return;
      }
      if (this.forms.productType === "Item" && !this.comboForm.comboID) {
        this.$message.warning("请选择组合主产品SKU");
        return;
      }
      if (this.forms.productType === "Main") {
        this.comboForm.comboID = this.forms.id;
      } else {
        this.comboForm.detailID = this.forms.id;
      }
      submitSkuCombo(this.comboForm).then((res) => {
        this.$message({ type: res.type, message: res.content });
        if (res.code === 200 || res.data) {
          this.$refs.comboDialog.toggle();
          this.loadComboList();
        }
      });
    },
    fetchs() {
      this.querys.filters = [];
      if (this.detailCode)
        this.querys.filters.push({
          name: "detailCode",
          value: "%" + this.detailCode + "%",
          operate: 5,
        });
      let { data, records, total, ...search } = {
        ...this.querys,
      };

      fetchSkuList(search).then((res) => {
        this.querys = { ...res.data };
      });
    },
    tableHandler(query) {
      this.querys = { ...this.querys, ...query };
      this.fetchs();
    },
    currHandler(row) {
      this.currRow = row;
    },
    pageHandler(page) {
      this.querys.page = page;
      this.fetchs();
    },
    sizeHandler(rows) {
      this.querys.rows = rows;
      this.fetchs();
    },
    sortHandler(order) {
      this.querys.sidx = order.prop;
      this.querys.sord = order.order;
      this.fetchs();
    },
    // //控制dialog宽度与子组件控制关闭弹窗
    // getdialogWidth(data) {
    //   if (data === "80%" || data === "30%") {
    //     this.dialogWidth = data;
    //   } else {
    //     this.centerDialogVisible = false;
    //   }
    // },
    // 多选变更处理
    handleSelectionChange(rows) {
      this.selectedRows = rows;
    },
    // 批量上下架
    batchStatus(enabled) {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请先选择要操作的数据');
        return;
      }
      
      const ids = this.selectedRows.map(row => row.id);
      const statusText = enabled ? '上架' : '下架';
      
      this.$confirm(`确定要批量${statusText}选中的 ${ids.length} 条数据吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        batchSkuStatus(ids, enabled)
          .then(res => {
            const { code, content, data } = res || {};
            if (code === 200) {
              const successCount = data?.successCount ?? ids.length;
              const total = data?.total ?? ids.length;
              this.$message.success(content || `操作成功：成功 ${successCount} 条，共 ${total} 条`);
              this.fetchs();
              this.selectedRows = [];
            } else {
              this.$message.error(content || '操作失败');
            }
          })
          .catch(err => {
            this.$message.error('操作失败：' + (err.message || '网络错误'));
          });
      }).catch(() => {
        this.$message.info('已取消操作');
      });
    },
    updateStatus(row, enabled) {
      if (!row || !row.id) return;
      const statusText = enabled ? '上架' : '下架';
      this.$confirm(`确定要${statusText}该SKU吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        batchSkuStatus([row.id], enabled).then(res => {
          const { code, content } = res || {};
          if (code === 200) {
            this.$message.success(content || '操作成功');
            this.fetchs();
          } else {
            this.$message.error(content || '操作失败');
          }
        });
      });
    }
  },
};
</script>
<style lang="less">
.xlsdialog {
  .el-dialog__body {
    max-height: 80vh;
    overflow-y: auto;
  }
}

.el-form .el-date-editor {
  width: 220px;
}

.sub-toolbar {
  margin: 10px 0;
}
</style>
